$(document).ready(function () {
  let selectedOption = $(
    "button[role='option'][aria-selected='true'][data-inventory-management='shopify']"
  )[0];

  let varQuantity = $(selectedOption).data("variant-quantity");
  let isTracked = $(selectedOption).data("inventory-management") == "shopify";

  if (isTracked) {
    if (varQuantity <= 1) {
      $("#stockStatus").text("Limited Stock");
      $("#stockStatus").addClass("limited_stock");
    } else {
      $("#stockStatus").text("In Stock");
      $("#stockStatus").removeClass("limited_stock");
    }
  } else {
    $("#stockStatus").text("");
  }

  window.addEventListener("locationchange", () => {
    selectedOption = $(
      "button[role='option'][aria-selected='true'][data-inventory-management='shopify']"
    );

    varQuantity = $(selectedOption).data("variant-quantity");
    isTracked = $(selectedOption).data("inventory-management") == "shopify";

    if (isTracked) {
      if (varQuantity <= 1) {
        $("#stockStatus").text("Limited Stock");
        $("#stockStatus").addClass("limited_stock");
      } else {
        $("#stockStatus").text("In Stock");
        $("#stockStatus").removeClass("limited_stock");
      }
    } else {
      $("#stockStatus").text("");
    }
  });

  // let formData = {
  //   'items': [{
  //    'id': 36110175633573,
  //    'quantity': 2
  //    }]
  //  };
  //

  // =============== MULTIPLE VARIANTS (START) =============

  $(document).on("click", ".p-quick-option-container", function (e) {
    e.stopPropagation();
    const id = $(e.target).data("variant-id");
    const prodId = $(e.target).data("product-id");

    console.log("CHECKING ID", id, "typeof ID:");

    $(`.product-${prodId} .spinner-bg`).removeAttr('hidden');
    $(`.product-${prodId} .line-item__loader-quick-shop`).removeAttr('hidden');
    $(`.product-${prodId} .line-item__loader-spinner`).removeAttr('hidden');

    console.log("CHECKING ID", id, "typeof ID:");
    if (!$(e.target).hasClass("p-out-stock") && typeof id == "number") {
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((cartContent) => {
          console.log(cartContent);

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );

          // $(this)
          //   .parent(".p-options-container")
          //   .first()
          //   .toggleClass("p-visible")
          //   .siblings(".p-quick-add-multiple")
          //   .first()
          //   .toggleClass("p-hidden");

          // setTimeout(function () {
          //   document.getElementById("mini-cart").open = true;

          //   window.YouPay.mountAllCartButtons();
          // }, 1500);
        })
        .then(()=>{

          $('.spinner-bg').attr('hidden',true);
          $('.line-item__loader-quick-shop').attr('hidden',true);
          $('.line-item__loader-spinner').attr('hidden',true);

          document.getElementById("mini-cart").open = true;
          window.YouPay.mountAllCartButtons();

        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  });

  // =============== MULTIPLE VARIANTS (END) =============

   // =============== SINGLE VARIANT (START) =============
  
  $(document).on("click", ".p-single", function (e) {
    if (!$(this).hasClass("p-out-stock")) {

      $(this).find('.spinner-bg').removeAttr('hidden');
      $(this).find('.line-item__loader-quick-shop').removeAttr('hidden');
      $(this).find('.line-item__loader-spinner').removeAttr('hidden');

      const id = $(this).children(".p-quick-add").first().data("variant-id");
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        }),
      })
      .then((response) => response.json())
        .then((cartContent) => {
          console.log(cartContent);
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );

          // setTimeout(function () {
          //   document.getElementById("mini-cart").open = true;

          //   window.YouPay.mountAllCartButtons();
          // }, 1500);
        })
        .then(()=>{

          $('.spinner-bg').attr('hidden',true);
          $('.line-item__loader-quick-shop').attr('hidden',true);
          $('.line-item__loader-spinner').attr('hidden',true);

          document.getElementById("mini-cart").open = true;
          window.YouPay.mountAllCartButtons();

        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  });

  // =============== SINGLE VARIANT (END) =============

  

  $(document).on("click", ".p-multiple", function (event) {
    event.stopPropagation();
    $(this).children(".p-quick-add-multiple").first().toggleClass("p-hidden");
    $(this).children(".p-options-container").first().toggleClass("p-visible");
  });
  // $(document).on("mouseleave", ".p-options-container",function (e) {
  //   $(e.target).toggleClass("p-visible");
  //   $(e.target).siblings(".p-quick-add-multiple").first().toggleClass("p-hidden");
  // });

  console.log("READY!!");
});
